import React, { useEffect } from "react";
import { Text } from "@kidslivesafe/sc-react";
import { useHandlePageNavigate } from "../../../hooks/hooks";

const RemoveFromView: React.FC = () => {
  const handleNavigate = useHandlePageNavigate();

  useEffect(() => {
    handleNavigate("/protection/confirm");
  }, [handleNavigate]);

  return <Text>Redirecting...</Text>;
};

export default RemoveFromView;
